import { copyEntity, } from '@dossierhq/core';
export const CACHE_KEYS = {
    adminChangelogEvents(query, paging) {
        return ['dossierhq/useAdminChangelogEvents', query, paging];
    },
    adminChangelogEventsTotalCount(query) {
        return ['dossierhq/useAdminChangelogEventsTotalCount', query];
    },
    adminEntity(reference) {
        return ['dossierhq/useAdminEntity', reference];
    },
    adminEntitiesSample(query, options) {
        return ['dossierhq/useAdminEntitiesSample', query, options];
    },
    adminEntities(query, paging) {
        return ['dossierhq/useAdminEntities', query, paging];
    },
    adminEntitiesTotalCount(query) {
        return ['dossierhq/useAdminEntitiesTotalCount', query];
    },
    schema: 'dossierhq/useAdminSchema',
    publishedEntity(reference) {
        return ['dossierhq/usePublishedEntity', reference];
    },
    publishedEntitiesSample(query, options) {
        return ['dossierhq/usePublishedEntitiesSample', query, options];
    },
    publishedEntities(query, paging) {
        return ['dossierhq/usePublishedEntities', query, paging];
    },
    publishedEntitiesTotalCount(query) {
        return ['dossierhq/usePublishedEntitiesTotalCount', query];
    },
    publishedSchema: 'dossierhq/usePublishedSchema',
};
function geInitialCacheKey(key) {
    if (typeof key === 'string') {
        return key;
    }
    if (Array.isArray(key) && typeof key[0] === 'string') {
        return key[0];
    }
    return null;
}
export function clearCacheDueToSchemaMigrations(mutate) {
    mutate((key) => {
        const initialKey = geInitialCacheKey(key);
        const shouldMutate = initialKey && initialKey.startsWith('dossierhq');
        return shouldMutate;
    });
}
export function updateCacheSchemas(cache, mutate, schema) {
    const hasAdmin = !!cache.get(CACHE_KEYS.schema);
    const hasPublished = !!cache.get(CACHE_KEYS.publishedSchema);
    if (hasAdmin || hasPublished) {
        if (hasAdmin) {
            mutate(CACHE_KEYS.schema, schema);
        }
        if (hasPublished) {
            const publishedSchema = schema?.toPublishedSchema();
            mutate(CACHE_KEYS.publishedSchema, publishedSchema);
        }
    }
}
export function updateCacheEntity(mutate, entity) {
    const key = CACHE_KEYS.adminEntity({ id: entity.id });
    mutate(key, entity);
}
export function updateCacheEntityInfo(mutate, payload) {
    const key = CACHE_KEYS.adminEntity({ id: payload.id });
    mutate(key, (entity) => {
        if (!entity)
            return entity;
        return copyEntity(entity, { info: { status: payload.status, updatedAt: payload.updatedAt } });
    });
}
export function removeCacheEntity(mutate, reference) {
    const key = CACHE_KEYS.adminEntity(reference);
    mutate(key, undefined);
}
export function invalidateChangelogEvents(mutate) {
    const keyString = CACHE_KEYS.adminChangelogEvents(undefined, undefined)[0];
    mutate((key) => {
        const initialKey = geInitialCacheKey(key);
        const shouldMutate = initialKey === keyString;
        return shouldMutate;
    });
}
//# sourceMappingURL=CacheUtils.js.map